export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-de_de@2x.e525a757.png";